import React, { useState } from 'react';
import { FadeIn, CTAButton, Section } from './Shared';
import { useCountdown } from '../hooks/useCountdown';
import { CheckCircle2, AlertTriangle, Plus, Minus } from 'lucide-react';
import { PRODUCTS } from './MetaPixel';
export const ProductTomos = () => {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    emoji: '📗',
    title: 'Nivel 1 — Mentalidad e Identidad Pro',
    sessions: '50 páginas',
    months: 'Base del sistema',
    desc: 'El cambio de mentalidad de barbero a dueño. Costo de la silla vacía. El número mágico. Cliente ideal.',
    color: 'bg-[#C9A84C]',
    borderColor: 'border-t-[#C9A84C]'
  }, {
    emoji: '📘',
    title: 'Nivel 2 — Configuración de la Máquina',
    sessions: '50 páginas',
    months: 'Infraestructura técnica',
    desc: 'Meta Business Suite, WhatsApp Business extremo, Pixel, anti-bloqueos y validación final.',
    color: 'bg-[#3B82F6]',
    borderColor: 'border-t-[#3B82F6]'
  }, {
    emoji: '📕',
    title: 'Nivel 3 — Anuncios Imantados',
    sessions: '50 páginas',
    months: 'El motor de citas',
    desc: 'Oferta irresistible, video-ads de 15 segundos, segmentación de 2km, estrategia del dólar diario.',
    color: 'bg-[#C0392B]',
    borderColor: 'border-t-[#C0392B]'
  }, {
    emoji: '📙',
    title: 'Nivel 4 — Cierre Maestro en WhatsApp',
    sessions: '50 páginas',
    months: 'Conversión de dinero',
    desc: 'El guion exacto para convertir consultas en citas. Scripts probados. Manejo de objeciones.',
    color: 'bg-[#F59E0B]',
    borderColor: 'border-t-[#F59E0B]'
  }, {
    emoji: '📓',
    title: 'Nivel 5 — La Agenda Blindada',
    sessions: '50 páginas',
    months: 'Fidelización y retención',
    desc: 'Sistema de turnos anticipados, reactivación de clientes fríos y programa de referidos.',
    color: 'bg-[#8B5CF6]',
    borderColor: 'border-t-[#8B5CF6]'
  }, {
    emoji: '📔',
    title: 'Nivel 6 — Escalamiento e Imperio',
    sessions: '50 páginas',
    months: 'Libertad y crecimiento',
    desc: 'Segunda silla, equipo, delegación y expansión. Del barbero al dueño de barbería.',
    color: 'bg-[#27AE60]',
    borderColor: 'border-t-[#27AE60]'
  }];
  const features = ['Objetivo del nivel claro', 'Herramientas descargables', 'Scripts listos para copiar', 'Ejercicios de implementación', 'Casos reales de barbería', 'Checklist de acción semanal', 'Una página por concepto', 'Abrís, leés 30 segundos y ejecutás'];
  const featureChips = ['✅ Sistema de anuncios Meta Ads', '✅ Guiones de WhatsApp listos', '✅ Estrategia dólar diario', '✅ Fidelización y retención', '✅ Plan de escalamiento', '✅ 300 páginas de sistema'];
  return <Section className="bg-bg-base" data-id="element-18">
      <FadeIn className="text-center mb-8 md:mb-12" data-id="element-19">
        {/* Yellow trust pill */}
        <div className="flex justify-center mb-4 md:mb-5" data-id="element-20">
          <span className="inline-flex items-center gap-1.5 font-sans font-semibold uppercase tracking-[1.5px] text-[9px] md:text-[10px] text-brandOrange bg-brandOrange/10 border border-brandOrange/30 rounded-full px-3 py-1" data-id="element-21">
            🏆 Sistema N°1 para Barberos
          </span>
        </div>

        <h2 className="font-display font-extrabold uppercase md:text-[64px] gold-metallic mb-3 md:mb-4 text-[40px] leading-[1.1]" data-id="element-22">
          MEGAPACK BARBERO PRO™
        </h2>
        <p className="font-sans text-[16px] md:text-[20px] leading-[1.5] md:leading-[1.7] text-txt-primary max-w-2xl mx-auto" data-id="element-23">
          6 Niveles + 6 Bonos — El sistema completo para llenar tu agenda,
          cobrar más y nunca más improvisar.
        </p>
      </FadeIn>

      {/* Hero mockup — moved up under title */}
      <FadeIn delay={0.15} className="mb-8 md:mb-12" data-id="element-24">
        <img src="https://cdn.magicpatterns.com/uploads/sFEQjEmUsZK8vJ3cEmMSwK/mockup_principal_sticker.png" alt="MEGAPACK BARBERO PRO" className="w-full max-w-[600px] mx-auto h-auto object-contain drop-shadow-2xl" data-id="element-25" />
      </FadeIn>

      {/* 6 colored Nivel strip */}
      <FadeIn delay={0.2} className="mb-5 md:mb-7" data-id="element-26">
        <div className="grid grid-cols-6 gap-2 md:gap-3 max-w-3xl mx-auto px-2 md:px-0" data-id="element-27">
          {tomos.map((tomo, i) => <div key={i} className={`${tomo.color} aspect-[3/4] rounded-[10px] md:rounded-[14px] flex items-center justify-center text-center shadow-[0_4px_12px_rgba(0,0,0,0.4)] relative overflow-hidden`} data-id="element-28">
              <div className="absolute inset-0 bg-gradient-to-b from-white/15 to-transparent h-1/2 pointer-events-none" data-id="element-29"></div>
              <span className="font-display uppercase tracking-[1px] text-white text-[10px] md:text-[14px] leading-[1.1] drop-shadow-md relative z-10 px-1" data-id="element-30">
                Nivel
                <br data-id="element-31" />
                {i + 1}
              </span>
            </div>)}
        </div>
      </FadeIn>

      {/* "6 Niveles Completos" badge pill */}
      <FadeIn delay={0.25} className="flex justify-center mb-7 md:mb-10" data-id="element-32">
        <span className="inline-flex items-center font-display uppercase tracking-[2px] text-[12px] md:text-[14px] text-black bg-brandOrange rounded-full px-5 py-1.5 md:px-6 md:py-2" data-id="element-33">
          6 Niveles Completos
        </span>
      </FadeIn>

      {/* Feature chip pills */}
      <FadeIn delay={0.3} className="mb-8 md:mb-12" data-id="element-34">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-1.5 md:gap-2 max-w-xl mx-auto px-2" data-id="element-35">
          {featureChips.map((chip, i) => <span key={i} className="inline-flex items-center gap-1.5 bg-bg-card border border-brandOrange/40 text-txt-primary font-sans font-semibold uppercase tracking-[0.5px] text-[9.5px] md:text-[11px] rounded-full px-2.5 py-1 md:px-3 md:py-1.5 whitespace-nowrap" data-id="element-36">
              <span className="text-success text-[10px] md:text-[12px] leading-none" data-id="element-37">
                ✅
              </span>
              <span className="truncate" data-id="element-38">{chip.replace('✅ ', '')}</span>
            </span>)}
        </div>
      </FadeIn>

      {/* "Lo que recibís" pill header */}
      <FadeIn delay={0.35} className="flex justify-center mb-7 md:mb-10" data-id="element-39">
        <span className="inline-flex items-center gap-2 bg-bg-card border border-brandOrange/40 rounded-full px-5 py-2 md:px-7 md:py-3" data-id="element-40">
          <span className="text-[16px] md:text-[20px]" data-id="element-41">📦</span>
          <span className="font-display uppercase tracking-[1.5px] text-[14px] md:text-[18px] text-txt-primary" data-id="element-42">
            Lo que recibís:
          </span>
        </span>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-12 md:mb-16 max-w-3xl md:max-w-none mx-auto" data-id="element-43">
        {tomos.map((tomo, i) => {
        const isOpen = openTomo === i;
        // Map the bg color class to a top-bar background color
        const topBarColor = tomo.color;
        return <FadeIn key={i} delay={Math.min(i * 0.04, 0.18)} data-id="element-44">
              <div className="bg-bg-card rounded-[14px] border border-line overflow-hidden relative" data-id="element-45">
                {/* Top colored accent bar */}
                <div className={`${topBarColor} h-[3px] w-full`} data-id="element-46"></div>

                <button type="button" onClick={() => setOpenTomo(isOpen ? null : i)} className="w-full flex items-center gap-3 px-3 py-2.5 md:px-4 md:py-3 text-left" aria-expanded={isOpen} data-id="element-47">
                  {/* Emoji book icon */}
                  <span className="text-[24px] md:text-[28px] leading-none shrink-0" data-id="element-48">
                    {tomo.emoji}
                  </span>

                  {/* Title + pills */}
                  <div className="min-w-0 flex-1" data-id="element-49">
                    <h3 className="font-sans font-bold text-[13px] md:text-[15px] text-txt-primary leading-[1.2] mb-1.5" data-id="element-50">
                      {tomo.title}
                    </h3>
                    <div className="flex items-center gap-1.5 flex-wrap" data-id="element-51">
                      <span className="font-sans font-bold uppercase tracking-[0.5px] text-[9px] md:text-[10px] text-brandOrange bg-brandOrange/15 rounded-md px-1.5 py-0.5" data-id="element-52">
                        {tomo.sessions}
                      </span>
                      <span className="font-sans font-bold uppercase tracking-[0.5px] text-[9px] md:text-[10px] text-txt-muted bg-bg-highlight rounded-md px-1.5 py-0.5" data-id="element-53">
                        {tomo.months}
                      </span>
                    </div>
                  </div>

                  {/* Plus / minus toggle */}
                  <span className="shrink-0 w-7 h-7 md:w-8 md:h-8 rounded-full bg-bg-highlight flex items-center justify-center text-txt-primary" data-id="element-54">
                    {isOpen ? <Minus size={14} data-id="element-55" /> : <Plus size={14} data-id="element-56" />}
                  </span>
                </button>

                {/* Expanded description */}
                {isOpen && <div className="px-3 pb-3 md:px-4 md:pb-4 pt-0" data-id="element-57">
                    <p className="font-sans text-[12.5px] md:text-[14px] leading-[1.5] text-txt-primary opacity-80 pl-[36px] md:pl-[42px]" data-id="element-58">
                      {tomo.desc}
                    </p>
                  </div>}
              </div>
            </FadeIn>;
      })}
      </div>

      <FadeIn delay={0.4} data-id="element-59">
        <div className="bg-bg-card border border-brandOrange/30 rounded-[20px] p-6 md:p-10 max-w-4xl mx-auto" data-id="element-60">
          <h3 className="font-display uppercase tracking-[1.5px] text-[20px] md:text-[26px] text-brandOrange text-center leading-snug mb-5 md:mb-8" data-id="element-61">
            Cada nivel incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-3 md:gap-4 mb-6 md:mb-8" data-id="element-62">
            {features.map((feature, i) => <div key={i} className="flex items-start gap-2 md:gap-3" data-id="element-63">
                <CheckCircle2 className="text-brandOrange shrink-0 mt-0.5 w-4 h-4 md:w-5 md:h-5" data-id="element-64" />
                <span className="font-sans font-medium text-[14px] md:text-[16px] leading-[1.6] text-txt-primary" data-id="element-65">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="text-center pt-5 md:pt-6 border-t border-line" data-id="element-66">
            <p className="font-sans font-bold text-base md:text-xl leading-snug text-txt-primary" data-id="element-67">
              <span className="text-brandOrange" data-id="element-68">Una página</span> por concepto
              — abrís el nivel,{' '}
              <span className="text-brandOrange" data-id="element-69">leés 30 segundos</span> y
              ejecutás. <span className="text-brandOrange" data-id="element-70">Así de simple.</span>
            </p>
          </div>
        </div>
      </FadeIn>
    </Section>;
};
export const Bonuses = () => {
  const bonuses = [{
    num: '01',
    icon: '🎯',
    title: 'Kit de Ofertas Imposibles',
    desc: '25 ofertas listas para activar clientes. Copiás, pegás y publicás.',
    value: '$15.000'
  }, {
    num: '02',
    icon: '📝',
    title: 'Banco de 100 Copys',
    desc: 'Textos listos para Meta Ads, estados de WhatsApp y reactivación.',
    value: '$12.000'
  }, {
    num: '03',
    icon: '✅',
    title: 'Checklist Anuncio en 15 Min',
    desc: 'Revisá cada punto antes de publicar. Sin errores evitables.',
    value: '$10.000'
  }, {
    num: '04',
    icon: '💬',
    title: '60 Respuestas Rápidas WhatsApp',
    desc: 'Atajos para WhatsApp Business. Respondés en 3 segundos.',
    value: '$12.000'
  }, {
    num: '05',
    icon: '📸',
    title: 'Mini Guía de Fotos que Venden',
    desc: 'Los 5 ángulos, la luz y la edición mínima que detiene el scroll.',
    value: '$10.000'
  }, {
    num: '06',
    icon: '📊',
    title: 'Publicidad Rápida IG + FB',
    desc: '3 campañas de tráfico para que el barrio te conozca.',
    value: '$10.000'
  }];
  return <Section className="bg-bg-alt" data-id="element-71">
      <FadeIn className="text-center mb-8 md:mb-14" data-id="element-72">
        <h2 className="font-display font-extrabold uppercase md:text-[52px] text-txt-primary mb-2 md:mb-4 text-[36px]" data-id="element-73">
          + 6 BONOS ESTRATÉGICOS
        </h2>
        <p className="font-sans text-[15px] md:text-[17px] leading-[1.5] md:leading-[1.7] text-txt-primary opacity-70" data-id="element-74">
          Incluidos en todas las opciones — sin costo extra
        </p>
      </FadeIn>

      <div className="flex flex-col gap-2 md:gap-3 mb-8 md:mb-12 max-w-3xl mx-auto" data-id="element-75">
        {bonuses.map((bono, i) => <FadeIn key={i} delay={Math.min(i * 0.04, 0.18)} data-id="element-76">
            <div className="bg-bg-base rounded-[12px] border border-brandOrange/40 px-3 py-2.5 md:px-5 md:py-4 flex items-center gap-3 md:gap-4" data-id="element-77">
              {/* Icon block */}
              <div className="shrink-0 w-10 h-10 md:w-12 md:h-12 rounded-[10px] bg-brandOrange/10 border border-brandOrange/30 flex items-center justify-center text-[20px] md:text-[24px]" data-id="element-78">
                {bono.icon}
              </div>

              {/* Content */}
              <div className="min-w-0 flex-1" data-id="element-79">
                <div className="flex items-center gap-2 mb-0.5" data-id="element-80">
                  <span className="font-display font-bold uppercase tracking-[1px] text-[10px] md:text-[12px] text-brandOrange" data-id="element-81">
                    BONO {bono.num}
                  </span>
                </div>
                <h3 className="font-sans font-bold text-[13px] md:text-[16px] text-txt-primary leading-tight mb-0.5 md:mb-1 truncate" data-id="element-82">
                  {bono.title}
                </h3>
                <p className="hidden md:block font-sans text-[13px] text-txt-primary opacity-70 leading-[1.4]" data-id="element-83">
                  {bono.desc}
                </p>
              </div>

              {/* Price */}
              <div className="shrink-0 flex flex-col items-end gap-0.5" data-id="element-84">
                <span className="font-sans font-normal text-[11px] md:text-[14px] line-through text-danger" data-id="element-85">
                  {bono.value}
                </span>
                <span className="text-success font-sans font-bold uppercase tracking-[0.5px] text-[10px] md:text-[13px]" data-id="element-86">
                  GRATIS
                </span>
              </div>
            </div>
          </FadeIn>)}
      </div>

      <FadeIn delay={0.4} className="max-w-2xl mx-auto pt-3" data-id="element-87">
        <div className="relative text-center bg-bg-card border-2 border-brandOrange p-6 md:p-10 rounded-[20px]" data-id="element-88">
          <span aria-hidden="true" className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brandOrange text-black font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] px-3 py-1 rounded-full whitespace-nowrap shadow-md z-10" data-id="element-89">
            💰 VALOR TOTAL
          </span>
          <p className="font-display uppercase tracking-[1px] text-[20px] md:text-[28px] leading-[1.1] text-txt-primary mt-2 mb-2" data-id="element-90">
            Valor total de los 6 Bonos
          </p>
          <p className="font-sans font-normal text-[20px] md:text-[28px] line-through text-danger mb-3" data-id="element-91">
            $69.000
          </p>
          <p className="font-display font-black text-[28px] md:text-[44px] leading-[1.1] text-brandOrange mb-2" data-id="element-92">
            🎁 GRATIS — Solo con tu MEGAPACK
          </p>
          <p className="font-sans text-[13px] md:text-[14px] leading-[1.5] text-txt-primary opacity-80" data-id="element-93">
            Incluidos en todas las opciones. Siempre.
          </p>
        </div>
      </FadeIn>
    </Section>;
};
export const UrgencyCounter = () => {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="bg-bg-base px-4 md:px-6 py-10 md:py-20 overflow-hidden relative" data-id="element-94">
      {/* Red urgency top stripe */}
      <div className="absolute top-0 left-0 right-0 bg-danger text-white text-center py-1.5 md:py-2 px-3 font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[13px] animate-pulse" data-id="element-95">
        🚨 ATENCIÓN — ESTA OFERTA NO SE VUELVE A REPETIR
      </div>
      <div className="border-y-2 border-danger absolute inset-x-0 top-0 bottom-0 pointer-events-none" data-id="element-96"></div>

      <div className="max-w-[1100px] mx-auto pt-6 md:pt-8" data-id="element-97">
        <FadeIn className="max-w-3xl mx-auto" data-id="element-98">
          <div className="text-center space-y-5 md:space-y-6 max-w-lg mx-auto" data-id="element-99">
            <div data-id="element-100">
              <h3 className="font-sans font-bold uppercase tracking-[1.5px] text-[14px] md:text-[16px] text-danger animate-pulse mb-1" data-id="element-101">
                ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
              </h3>
              <p className="font-sans text-[12px] md:text-[13px] text-txt-muted" data-id="element-102">
                Cuando llegue a 00:00:00, el precio sube. Punto.
              </p>
            </div>

            <div className="flex justify-center gap-3 md:gap-5 text-brandOrange" data-id="element-103">
              <div className="bg-bg-card border-2 border-danger rounded-[14px] w-[80px] h-[90px] md:w-[100px] md:h-[110px] flex flex-col items-center justify-center shadow-[0_0_30px_rgba(192,57,43,0.4)]" data-id="element-104">
                <div className="font-display font-normal text-[50px] md:text-[80px] leading-none text-brandOrange" data-id="element-105">
                  {hours.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] mt-1 text-txt-primary" data-id="element-106">
                  hs
                </div>
              </div>
              <div className="font-display font-normal text-[50px] md:text-[80px] py-2 flex items-center" data-id="element-107">
                :
              </div>
              <div className="bg-bg-card border-2 border-danger rounded-[14px] w-[80px] h-[90px] md:w-[100px] md:h-[110px] flex flex-col items-center justify-center shadow-[0_0_30px_rgba(192,57,43,0.4)]" data-id="element-108">
                <div className="font-display font-normal text-[50px] md:text-[80px] leading-none text-brandOrange" data-id="element-109">
                  {minutes.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] mt-1 text-txt-primary" data-id="element-110">
                  min
                </div>
              </div>
              <div className="font-display font-normal text-[50px] md:text-[80px] py-2 flex items-center" data-id="element-111">
                :
              </div>
              <div className="bg-bg-card border-2 border-danger rounded-[14px] w-[80px] h-[90px] md:w-[100px] md:h-[110px] flex flex-col items-center justify-center shadow-[0_0_30px_rgba(192,57,43,0.4)]" data-id="element-112">
                <div className="font-display font-normal text-[50px] md:text-[80px] leading-none text-brandOrange" data-id="element-113">
                  {seconds.toString().padStart(2, '0')}
                </div>
                <div className="font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[12px] mt-1 text-txt-primary" data-id="element-114">
                  seg
                </div>
              </div>
            </div>

            <div className="font-sans font-bold text-[14px] md:text-[16px] text-danger leading-snug" data-id="element-115">
              🔥 Después sube el precio. No vuelve.
            </div>

            <div className="pt-2" data-id="element-116">
              <div className="flex justify-between font-sans text-[12px] md:text-[14px] leading-[1.5] text-txt-primary mb-2" data-id="element-117">
                <span data-id="element-118">Cupos al precio de lanzamiento</span>
                <span className="text-danger font-bold" data-id="element-119">¡Quedan pocos!</span>
              </div>
              <div className="w-full bg-line rounded-full h-2.5 mb-2 overflow-hidden" data-id="element-120">
                <div className="bg-gradient-to-r from-danger to-brandOrange h-full rounded-full" style={{
                width: '71%'
              }} data-id="element-121"></div>
              </div>
              <p className="font-sans font-bold text-[11px] md:text-[12px] text-danger text-right" data-id="element-122">
                ⚠️ 71% de los cupos ya tomados
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};
export const Pricing = () => {
  const [selected, setSelected] = useState<'plus' | 'basic'>('plus');
  const ctaText = selected === 'plus' ? 'SÍ, QUIERO EL SISTEMA COMPLETO' : 'SÍ, QUIERO EL MEGAPACK';
  return <Section className="bg-bg-base !py-8 md:!py-16" id="pricing" data-id="element-123">
      <FadeIn className="text-center mb-5 md:mb-8" data-id="element-124">
        <h2 className="font-display font-extrabold uppercase md:text-[52px] text-txt-primary text-[32px] leading-[1.1]" data-id="element-125">
          Elegí tu <span className="text-brandOrange" data-id="element-126">MEGAPACK:</span>
        </h2>
        <p className="font-sans text-[13px] md:text-[16px] leading-[1.4] text-txt-primary opacity-70 mt-2" data-id="element-127">
          Todas las opciones incluyen los 6 bonos estratégicos
        </p>
      </FadeIn>

      <div className="max-w-xl mx-auto flex flex-col gap-3 md:gap-4 mb-5 md:mb-7 relative pt-3" data-id="element-128">
        {/* Plus option — MÁS ELEGIDO ribbon attached to plus card */}
        <FadeIn delay={0.1} data-id="element-129">
          <div className="relative" data-id="element-130">
            {/* MÁS ELEGIDO pill */}
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brandOrange text-black font-sans font-bold uppercase tracking-[1.5px] text-[10px] md:text-[11px] px-3.5 py-1 rounded-full whitespace-nowrap z-10" data-id="element-131">
              ⭐ MÁS ELEGIDO
            </div>

            <button type="button" onClick={() => setSelected('plus')} aria-pressed={selected === 'plus'} className={`w-full text-left rounded-[14px] md:rounded-[18px] p-3 md:p-5 border-2 transition-all bg-bg-card flex gap-3 md:gap-4 items-start ${selected === 'plus' ? 'border-brandOrange' : 'border-line'}`} data-id="element-132">
              {/* Radio */}
              <span className={`shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'plus' ? 'border-brandOrange' : 'border-txt-muted'}`} data-id="element-133">
                {selected === 'plus' && <span className="w-2.5 h-2.5 rounded-full bg-brandOrange" data-id="element-134"></span>}
              </span>

              {/* Icon */}
              <span className="text-[22px] md:text-[28px] leading-none shrink-0" data-id="element-135">
                🏆
              </span>

              {/* Content */}
              <div className="min-w-0 flex-1" data-id="element-136">
                <div className="flex items-start justify-between gap-2" data-id="element-137">
                  <h3 className="font-display uppercase tracking-[0.5px] text-txt-primary text-[15px] md:text-[18px] leading-[1.1]" data-id="element-138">
                    MEGAPACK +<br data-id="element-139" />
                    <span className={selected === 'plus' ? 'text-brandOrange' : 'text-txt-primary'} data-id="element-140">
                      POTENCIADORES
                    </span>
                  </h3>
                  <div className="text-right shrink-0" data-id="element-141">
                    <p className="font-sans text-[11px] md:text-[13px] line-through text-danger leading-tight" data-id="element-142">
                      $49.990
                    </p>
                    <p className="font-display text-brandOrange text-[20px] md:text-[26px] leading-none" data-id="element-143">
                      $27.990
                    </p>
                  </div>
                </div>

                <span className="inline-block bg-success text-white font-sans font-bold uppercase tracking-[0.5px] text-[10px] md:text-[11px] px-2.5 py-0.5 rounded-full mt-1.5 mb-1.5" data-id="element-144">
                  AHORRÁS $12.000 🔥
                </span>

                <p className="font-sans text-[12px] md:text-[14px] leading-[1.35] text-txt-primary opacity-90" data-id="element-145">
                  6 Tomos + 6 Bonos + ✨{' '}
                  <span className={selected === 'plus' ? 'text-brandOrange font-semibold' : 'text-txt-primary font-semibold'} data-id="element-146">
                    6 Potenciadores de Especialización
                  </span>
                </p>
              </div>
            </button>
          </div>
        </FadeIn>

        {/* Basic option */}
        <FadeIn delay={0.2} data-id="element-147">
          <button type="button" onClick={() => setSelected('basic')} aria-pressed={selected === 'basic'} className={`w-full text-left rounded-[14px] md:rounded-[18px] p-3 md:p-5 border-2 transition-all bg-bg-card flex gap-3 md:gap-4 items-start ${selected === 'basic' ? 'border-brandOrange' : 'border-line'}`} data-id="element-148">
            {/* Radio */}
            <span className={`shrink-0 mt-0.5 w-5 h-5 rounded-full border-2 flex items-center justify-center transition-colors ${selected === 'basic' ? 'border-brandOrange' : 'border-txt-muted'}`} data-id="element-149">
              {selected === 'basic' && <span className="w-2.5 h-2.5 rounded-full bg-brandOrange" data-id="element-150"></span>}
            </span>

            {/* Icon */}
            <span className="text-[22px] md:text-[28px] leading-none shrink-0" data-id="element-151">
              📘
            </span>

            {/* Content */}
            <div className="min-w-0 flex-1" data-id="element-152">
              <div className="flex items-start justify-between gap-2" data-id="element-153">
                <h3 className="font-display uppercase tracking-[0.5px] text-txt-primary text-[15px] md:text-[18px] leading-[1.1]" data-id="element-154">
                  MEGAPACK{' '}
                  <span className={selected === 'basic' ? 'text-brandOrange' : 'text-txt-primary'} data-id="element-155">
                    BARBERO PRO
                  </span>
                </h3>
                <div className="text-right shrink-0" data-id="element-156">
                  <p className="font-sans text-[11px] md:text-[13px] line-through text-danger leading-tight" data-id="element-157">
                    $34.990
                  </p>
                  <p className="font-display text-brandOrange text-[20px] md:text-[26px] leading-none" data-id="element-158">
                    $19.990
                  </p>
                </div>
              </div>

              <p className="font-sans text-[12px] md:text-[14px] leading-[1.35] text-txt-primary opacity-90 mt-1.5" data-id="element-159">
                6 Tomos Completos + 6 Bonos incluidos
              </p>
            </div>
          </button>
        </FadeIn>
      </div>

      {/* Pointer + urgency line */}
      <FadeIn delay={0.3} data-id="element-160">
        <div className="text-center mb-3 md:mb-4 max-w-xl mx-auto" data-id="element-161">
          <p className="font-sans font-bold text-[13px] md:text-[15px] text-txt-primary mb-1.5" data-id="element-162">
            <span className="inline-block mr-1" data-id="element-163">👇</span>
            Tu próximo lunes empieza acá
          </p>
          <p className="font-sans font-semibold uppercase tracking-[1.5px] text-[10px] md:text-[12px] text-brandOrange" data-id="element-164">
            ⚡ Precio de lanzamiento — Por tiempo limitado
          </p>
        </div>
      </FadeIn>

      {/* Single dynamic CTA */}
      <FadeIn delay={0.35} data-id="element-165">
        <div className="max-w-xl mx-auto px-1" data-id="element-166">
          <CTAButton href={PRODUCTS[selected].checkoutUrl} fullWidth trackingProduct={selected} className="!py-4 md:!py-5 !text-[15px] md:!text-[18px]" data-id="element-167">
            {ctaText}
          </CTAButton>
        </div>
      </FadeIn>

      <FadeIn delay={0.4} data-id="element-168">
        <div className="flex flex-wrap justify-center gap-x-4 gap-y-1 mt-4 md:mt-6 font-sans text-[11px] md:text-[13px] text-txt-primary opacity-80" data-id="element-169">
          <span data-id="element-170">🔒 Pago 100% seguro</span>
          <span data-id="element-171">⚡ Acceso en 5 minutos</span>
          <span data-id="element-172">🛡️ Garantía 15 días</span>
        </div>
      </FadeIn>
    </Section>;
};
export const Potenciador = () => {
  const comparisons = [{
    bad: 'Llenás la agenda pero el ticket es siempre el mismo',
    good: 'Subís el ticket un 40% con los mismos clientes'
  }, {
    bad: 'Dependés 100% de Meta Ads para tener clientes',
    good: 'Google Maps te trae clientes gratis todos los días'
  }, {
    bad: 'No sabés exactamente cuánto ganás por mes',
    good: 'Claridad total de tus números y margen neto real'
  }, {
    bad: 'Tus anuncios son fotos que casi nadie ve',
    good: 'Videos que generan 3x más clics que las fotos'
  }, {
    bad: 'Si vos no estás, el negocio para',
    good: 'El local funciona aunque vos no estés'
  }];
  const volumes = [{
    icon: '💰',
    title: 'Upselling Barbero',
    sub: 'Ticket promedio +40%',
    desc: 'Subí tu facturación un 40% vendiendo más a los mismos clientes. Menú VIP, servicios de 5 minutos, membresías y guiones de silla.'
  }, {
    icon: '🗺️',
    title: 'Google Maps Domination',
    sub: 'Clientes gratis desde Google',
    desc: 'Aparecer 1° en tu barrio sin pagar Google. SEO local, sistema de reseñas y dominación de radio.'
  }, {
    icon: '💵',
    title: 'Finanzas del Barbero Empresario',
    sub: 'Libertad financiera',
    desc: 'Flujo de caja, margen neto real, sueldo del dueño y los 4 fondos que cambian todo para siempre.'
  }, {
    icon: '🎬',
    title: 'Video-Ads de Alto Impacto',
    sub: 'CapCut Edition',
    desc: 'El guion de 15 segundos que convierte. Edición rítmica, subtítulos y voiceover con el celular que ya tenés.'
  }, {
    icon: '🤝',
    title: 'Alianzas de Barrio',
    sub: 'Marketing guerrilla',
    desc: 'Que el barrio trabaje para tu barbería. Aliados, cupones cruzados, embajadores y referidos sin depender de Meta Ads.'
  }, {
    icon: '⚙️',
    title: 'Manual de Equipo',
    sub: 'Sistema que funciona sin vos',
    desc: 'SOPs, contratación, capacitación en 15 días, comisiones y el plan de apertura del segundo local.'
  }];
  return <Section className="bg-bg-alt" data-id="element-173">
      <FadeIn className="text-center max-w-3xl mx-auto mb-8 md:mb-12" data-id="element-174">
        <div className="inline-block font-sans font-bold uppercase tracking-[1px] text-[11px] md:text-[13px] text-brandOrange mb-3 md:mb-4" data-id="element-175">
          🚀 ¿QUÉ AGREGAN LOS POTENCIADORES?
        </div>
        <h2 className="font-display font-normal text-[28px] md:text-[40px] leading-[1.1] text-txt-primary mb-3 md:mb-5" data-id="element-176">
          El Megapack <span className="text-brandOrange" data-id="element-177">llena tu agenda.</span>
          <br data-id="element-178" />
          Los Potenciadores{' '}
          <span className="text-brandOrange" data-id="element-179">construyen el Imperio.</span>
        </h2>
        <p className="font-sans text-[13px] md:text-[16px] leading-[1.5] text-txt-primary opacity-70" data-id="element-180">
          6 volúmenes de especialización para el barbero que no se conforma con
          lo básico.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} className="max-w-6xl mx-auto mb-12 md:mb-16" data-id="element-181">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2.5 md:gap-3.5 mb-8 md:mb-10" data-id="element-182">
          {volumes.map((vol, i) => <div key={i} className="bg-bg-base border border-brandOrange/30 rounded-[12px] md:rounded-[14px] p-3.5 md:p-4 hover:border-brandOrange transition-all flex flex-col" data-id="element-183">
              <div className="flex items-center gap-2.5 md:gap-3 mb-2 md:mb-2.5" data-id="element-184">
                <div className="text-[20px] md:text-[26px] shrink-0" data-id="element-185">
                  {vol.icon}
                </div>
                <div className="min-w-0" data-id="element-186">
                  <h4 className="font-sans font-bold text-[14px] md:text-[15px] leading-[1.2] text-txt-primary" data-id="element-187">
                    {vol.title}
                  </h4>
                  <p className="font-sans font-medium text-[11px] md:text-[12px] text-brandOrange" data-id="element-188">
                    {vol.sub}
                  </p>
                </div>
              </div>
              <p className="font-sans text-[12px] md:text-[13px] leading-[1.4] text-txt-primary opacity-75 mb-2.5 flex-grow" data-id="element-189">
                {vol.desc}
              </p>
              <div className="font-sans font-medium text-[10.5px] md:text-[11.5px] text-txt-muted pt-2 border-t border-line" data-id="element-190">
                50 páginas · Sistema completo
              </div>
            </div>)}
        </div>

        <div className="bg-bg-base border border-brandOrange/30 rounded-[20px] p-5 md:p-7 text-center max-w-3xl mx-auto" data-id="element-191">
          <p className="font-display font-normal text-[22px] md:text-[30px] leading-[1.15] text-brandOrange mb-1.5" data-id="element-192">
            Total: 6 volúmenes · 300 páginas adicionales
          </p>
          <p className="font-sans text-[13px] md:text-[15px] leading-[1.5] text-txt-primary opacity-80" data-id="element-193">
            Para el barbero que no se conforma con lo básico.
          </p>
        </div>
      </FadeIn>

      <div className="max-w-4xl mx-auto" data-id="element-194">
        <div className="bg-bg-base rounded-[20px] overflow-hidden border border-line p-6 md:p-10" data-id="element-195">
          <div className="grid grid-cols-2 gap-4 md:gap-8 mb-6" data-id="element-196">
            <div className="font-sans font-bold text-[16px] md:text-[18px] text-danger" data-id="element-197">
              ❌ Sin Potenciadores
            </div>
            <div className="font-sans font-bold text-[16px] md:text-[18px] text-success" data-id="element-198">
              ✅ Con Potenciadores
            </div>
          </div>
          <div className="space-y-4 md:space-y-6" data-id="element-199">
            {comparisons.map((row, i) => <div key={i} className="grid grid-cols-2 gap-4 md:gap-8" data-id="element-200">
                <div className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.6] text-txt-primary opacity-70 flex items-start gap-2" data-id="element-201">
                  <span className="text-danger shrink-0" data-id="element-202">❌</span> {row.bad}
                </div>
                <div className="font-sans text-[14px] md:text-[16px] leading-[1.5] md:leading-[1.6] text-txt-primary flex items-start gap-2" data-id="element-203">
                  <span className="text-success shrink-0" data-id="element-204">✅</span> {row.good}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </Section>;
};